import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button, IconButton } from 'react-toolbox/lib/button';
import NumericInput from 'react-numeric-input';
// import Table from 'react-toolbox/lib/table';
// import { Tab, Tabs } from 'react-toolbox';
import Editor from '~/components/Editor';
// import Spinner from '~/components/Spinner';
import Tag from '~/components/Tag';
import { get, update } from '~/actions/articles';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

class ArticleDialog extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      edits: {
        article: {},
        eshop: {}
      },
      stock: {},
      currentTab: 0,
      eshopLoading: '',
      eshopLoaded: []
    };
  }

  componentDidMount() {
    get(this.props.dispatch, this.context.apiClient, this.props.data.id).then(
      r => this.setState({ stock: r.data.stock })
    );
  }

  getFields() {
    const fields = [
      { label: 'Name', key: 'name', props: { required: true } },
      { label: 'Image (url)', key: 'image' },
      { label: 'Description', key: 'description', props: { type: 'html' } },
      {
        label: 'Weight (grams)',
        key: 'weight',
        props: { type: 'number' }
      },
      { label: 'UPC', key: 'upc' },
      {
        label: 'Price',
        key: 'price',
        props: { type: 'number' }
      },
      {
        label: 'Price level 1',
        key: 'priceLevel1',
        props: { type: 'number' }
      },
      {
        label: 'Price level 2',
        key: 'priceLevel2',
        props: { type: 'number' }
      },
      {
        label: 'Price level 3',
        key: 'priceLevel3',
        props: { type: 'number' }
      },
      {
        label: 'Price level 4',
        key: 'priceLevel4',
        props: { type: 'number' }
      },
      {
        label: 'Price level 5',
        key: 'priceLevel5',
        props: { type: 'number' }
      },
      {
        label: 'Price level 6',
        key: 'priceLevel6',
        props: { type: 'number' }
      },
      {
        label: 'Price level 7',
        key: 'priceLevel7',
        props: { type: 'number' }
      },
      {
        label: 'Price level 8',
        key: 'priceLevel8',
        props: { type: 'number' }
      },
      {
        label: 'Price level 9',
        key: 'priceLevel9',
        props: { type: 'number' }
      },
      {
        label: 'Price level 10',
        key: 'priceLevel10',
        props: { type: 'number' }
      },
    ];
    return fields;
  }

  update() {
    update(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id,
      this.state.edits.article
    ).then(() =>
      this.setState({ edits: { ...this.state.edits, article: {} } })
    );
  }

  renderLocation(location) {
    if (location.type === 'external') {
      return <Tag type="location" id="external" />;
    }
    return <Tag type={location.type} id={location.id} />;
  }

  renderInput(editsName, article, field, key) {
    const { edits } = this.state;
    const articleEdits = edits[editsName];
    const value =
      !articleEdits || articleEdits[field.key] === undefined
        ? article[field.key]
        : articleEdits[field.key];

    const onChange = val =>
      this.setState({
        edits: {
          ...edits,
          [editsName]: {
            ...articleEdits,
            [field.key]: field.parseValue ? field.parseValue(val) : val
          }
        }
      });

    if (field.props && field.props.type === 'html') {
      return (
        <div key={key}>
          {field.label && <label htmlFor={key}>{field.label}</label>}
          <Editor
            format="html"
            value={value === undefined ? '' : value}
            onChange={onChange}
          />
        </div>
      );
    }
    if (field.props && field.props.type === 'number') {
      return (
        <div key={key}>
          <NumericInput
            value={value === undefined ? null : value}
            step={0.01}
            min={0}
            precision={3}
            onChange={onChange}
          />
          {field.label && <label htmlFor={key}>{field.label}</label>}
        </div>
      );
    }
    return (
      <Input
        key={key}
        label={field.label}
        value={value === undefined ? '' : value}
        onChange={onChange}
        {...field.props}
      />
    );
  }

  render() {
    const { article } = this.props;
    const fields = this.getFields();
    return (
      <div
        className={[
          styleDialog.background,
          styleDialog[this.props.transition]
        ].join(' ')}
        onClick={() => this.context.dialogClose(this.props.dialogId)}
      >
        <div
          className={styleDialog.container}
          onClick={e => e.stopPropagation()}
        >
          <IconButton
            className={styleDialog.closeButton}
            icon="close"
            onClick={() => this.context.dialogClose(this.props.dialogId)}
          />
          <div className={styleDialog.content}>
            <div className={styleLocal.row}>
              <div
                className={styleLocal.left}
                style={{ backgroundImage: `url(${article.image})` }}
              />
              <div className={styleLocal.right}>
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    this.update();
                  }}
                >
                  {fields.map((field, i) =>
                    this.renderInput(
                      'article',
                      article,
                      field,
                      `field_${i}`
                    )
                  )}
                  <Button label="Update" type="submit" primary raised />
                </form>
              </div>
            </div>
            <hr />
            {Object.values(this.state.stock).map(stock => (
              <div key={stock.location.id}>
                <div className={styleLocal.listArticle}>
                  {this.renderLocation(stock.location)}
                </div>
                <div className={styleLocal.listStock}>{stock.count}</div>
              </div>
            ))}
            {Object.keys(this.state.stock).length === 0 && (
              <div style={{ padding: '10px' }}>No articles in any stock</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    article: state.getIn(['articles', 'articles', props.data.id]).toJS(),
    locations: state.getIn(['locations', 'locations']).toJS(),
    containers: state.getIn(['containers', 'items']).toJS()
  };
};

export default connect(mapStateToProps)(ArticleDialog);



// WEBPACK FOOTER //
// ./app/dialogs/Article/index.js